// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"7f2b34c9","453":"20359781","968":"609dc28c"}[chunkId] + ".chunk.js";
};